export default {

    props: {

        client: {

            type     : Object,
            default  : null,
            required : false
        },
        caregiver: {

            type     : Object,
            default  : null,
            required : false
        },
    },

    data(){

        return {

            client_id    : '',
            caregiver_id : '',
        }
    },

    computed: {

        scopeduser(){

            if( this.client && this.client.id ) return this.client.id;
            if( this.caregiver && this.caregiver.id ) return this.caregiver.id;

            return '';
        }
    },

    methods: {

        createScoped(){

            window.open( `${this.baseUrl}/create?scopedUser=${this.scopeduser}`, '_blank' );
        }
    },

    watch: {

    },

    created(){

        if( this.client != null ) this.client_id = this.client.id;
        if( this.caregiver != null ) this.caregiver_id = this.caregiver.id;
    },

    mounted(){

        if( this.scopeduser && this.scopeduser.id ) this.addUser( this.scopeduser );
    }
}